import React from 'react';
import { Modal } from 'react-bootstrap';
import swal from 'sweetalert';

import { Plus, Trash2 } from 'lucide-react';
import i18n from '../../../../../i18n';
import { auctionApprove } from '../services/auctionApprovalServices';
import FileInputNew from '../../../../helpers/fileInputNew';

export class AuctionApproveModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_loading: false,
      input: {},
      errors: {},
      fileInputs: [],
      file_receipt: null,
      split_vat_enabled: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      input: { ...prevState.input, [name]: value },
    }));
  };

  onFileChange = (event) => {
    if (event.target.name === 'file_receipt') {
      this.setState({ file_receipt: event.target.files[0] });
    }
    if (event.target.name === 'invoice') {
      this.setState({ invoice: event.target.files[0] });
    }
  };

  onFileChangeNew = (e, index) => {
    const updatedInputs = [...this.state.fileInputs];
    updatedInputs[index].file = e.target.files[0];
    this.setState({ fileInputs: updatedInputs });
  };

  addNewFileInput = () => {
    this.setState((prevState) => ({
      fileInputs: [...prevState.fileInputs, { id: prevState.fileInputs.length + 1, file: null }],
    }));
  };

  removeFile = (index) => {
    this.setState((prevState) => ({
      fileInputs: prevState.fileInputs.filter((_, i) => i !== index),
    }));
  };

  validateOfflineForm = () => {
    const required = ['client_name', 'bank_name', 'account_number', 'payment_date'];

    for (let field of required) {
      if (!this.state.input[field]) {
        return false;
      }
    }
    return this.state.file_receipt !== null && this.state.invoice !== null;
  };

  async handleSubmit(event) {
    event.preventDefault();
    const { input } = this.state;
    const { selectedIds, groupId } = this.props;
    event.preventDefault();

    const isValidOffline = this.validateOfflineForm();

    if (!isValidOffline) {
      swal(i18n.t('failed'), i18n.t('all_mandatory'), 'error');
      return;
    }

    try {
      this.setState({ is_loading: true });
      let { fileInputs } = this.state;
      const formData = new FormData();

      // Common fields
      selectedIds.forEach((id, index) => {
        formData.append(`selected_ids[${index}]`, id);
      });
      formData.append('group_id', groupId);
      formData.append('client_name', input.client_name);
      formData.append('bank_name', input.bank_name);
      formData.append('account_number', input.account_number);
      formData.append('vat_account_status', this.state.split_vat_enabled ? 1 : 0);
      formData.append('vat_account_number', input.vat_account_number);
      formData.append('payment_date', input.payment_date);
      formData.append('remarks', input.remarks || '');

      if (this.state.file_receipt) {
        formData.append('attachment', this.state.file_receipt, this.state.file_receipt.name);
      }
      if (this.state.invoice) {
        formData.append('invoice', this.state.invoice, this.state.invoice.name);
      }

      if (fileInputs.length > 0) {
        fileInputs.forEach((input, index) => {
          if (input.file) {
            formData.append(`additional_attachments${index}`, input.file, input.file.name);
          }
        });
      }

      const response = await auctionApprove(formData);
      if (response && response.success) {
        swal(i18n.t('success'), i18n.t('auction_approved'), 'success');
        this.setState({ is_loading: false });
        if (this.props.onSuccess) {
          this.props.onSuccess(); // trigger parent refresh
        } else {
          this.props.onClose();
        }
      } else {
        swal(i18n.t('failed'), response.message, 'error');
        this.setState({ is_loading: false });
      }
    } catch (err) {
      console.log(err);
      this.setState({ is_loading: false });
    }
  }

  renderFileUpload = () => {
    const { fileInputs } = this.state;

    return (
      <div className="wallet-file-section">
        <div className="mb-3">
          <label className="wallet-form-label">{i18n.t('attachment')}</label>
          <div className="wallet-file-input-wrapper">
            <FileInputNew
              wrapperClass="wallet-file-input"
              placeholder={i18n.t('choose_file')}
              id="file_receipt"
              name="file_receipt"
              onChange={this.onFileChange}
              className="form-control"
              accept=".jpg,.jpeg,.png,.pdf"
            />
          </div>
        </div>
        {/* image 2  */}
        <div className="mb-3">
          <label className="wallet-form-label">{i18n.t('clinet_invoice')}</label>
          <div className="wallet-file-input-wrapper">
            <FileInputNew
              wrapperClass="wallet-file-input"
              placeholder={i18n.t('choose_file')}
              id="invoice"
              name="invoice"
              onChange={this.onFileChange}
              className="form-control"
              accept=".jpg,.jpeg,.png,.pdf"
            />
          </div>
        </div>
        {/* Additional files - only for offline tab */}

        <div className="wallet-additional-files">
          <label className="wallet-form-label">{i18n.t('additional_doc')}</label>
          {fileInputs.map((input, index) => (
            <div key={input.id} className="wallet-file-row mb-2">
              <div className="wallet-file-input-container">
                <FileInputNew
                  wrapperClass="wallet-file-input"
                  className="form-control"
                  placeholder={i18n.t('choose_file')}
                  name="file_receipt_addl"
                  id={`file_receipt_addl_${index}`}
                  onChange={(e) => this.onFileChangeNew(e, index)}
                />
                <button
                  type="button"
                  className="wallet-remove-file-btn"
                  onClick={() => this.removeFile(index)}
                  title="Remove file"
                >
                  <Trash2 size={20} />
                </button>
              </div>
            </div>
          ))}
          <button className="wallet-add-file-btn" onClick={this.addNewFileInput} type="button">
            {/* <i className="fa fa-plus" /> */}
            <Plus size={20} />
            <span>{i18n.t('add_new')}</span>
          </button>
        </div>
      </div>
    );
  };
  renderOfflineForm = () => {
    const { input, errors } = this.state;

    return (
      <div className="wallet-form-content">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('client_name')}</label>
            <input
              type="text"
              name="client_name"
              value={input.client_name || ''}
              onChange={this.handleChange}
              className="wallet-form-input"
              placeholder="Please enter client name"
            />
            <div className="wallet-error">{errors.client_name}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('bank_name')}</label>
            <input
              type="text"
              name="bank_name"
              value={input.bank_name || ''}
              onChange={this.handleChange}
              className="wallet-form-input"
              placeholder={i18n.t('bank_name')}
            />
            <div className="wallet-error">{errors.bank_name}</div>
          </div>

          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('account_number')}</label>
            <input
              type="text"
              name="account_number"
              value={input.account_number || ''}
              onChange={this.handleChange}
              className="wallet-form-input"
              placeholder={i18n.t('enter_account_number')}
            />
            <div className="wallet-error">{errors.account_number}</div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="mt-4">
              <label className="wallet-checkbox-wrapper">
                <input
                  type="checkbox"
                  id="split_vat_enabled"
                  name="split_vat_enabled"
                  checked={this.state.split_vat_enabled}
                  onChange={(e) => this.setState({ split_vat_enabled: e.target.checked })}
                />
                <span className="custom-checkbox"></span>
                <span className="wallet-form-label">
                  {i18n.t('split_vat_id_enabled')}
                  {/* Optional description */}
                  {/* <span className="label-description">Enable VAT split calculation for transactions</span> */}
                </span>
              </label>
            </div>
          </div>

          {this.state.split_vat_enabled && (
            <div className="col-md-6 mb-3">
              <label className="wallet-form-label">{i18n.t('vat_account_number')}</label>
              <input
                type="text"
                name="vat_account_number"
                value={input.vat_account_number || ''}
                onChange={this.handleChange}
                className="wallet-form-input"
                placeholder={i18n.t('enter_vat_account_number')}
              />
              <div className="wallet-error">{errors.vat_account_number}</div>
            </div>
          )}

          <div className="col-md-6 mb-3">
            <label className="wallet-form-label">{i18n.t('final_due_date')}</label>
            <input
              type="date"
              name="payment_date"
              value={input.payment_date || ''}
              onChange={this.handleChange}
              className="wallet-form-input"
              placeholder={i18n.t('payment_date')}
            />
            <div className="wallet-error">{errors.payment_date}</div>
          </div>
        </div>
      </div>
    );
  };
  render() {
    const { show, onClose } = this.props;
    const { is_loading, input } = this.state;
    return (
      <Modal
        show={show}
        onHide={onClose}
        size="lg"
        dialogClassName="wallet-modal-dialog"
        className="wallet-fund-modal"
      >
        <Modal.Header closeButton className="wallet-modal-header">
          <Modal.Title className="wallet-modal-title">
            <i className="fa fa-wallet mr-2"></i>
            {i18n.t('auction_approval')}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="wallet-modal-body">
          {/* Form Content */}
          <div className="wallet-form-container">
            <form className="wallet-form" autoComplete="off">
              {this.renderOfflineForm()}

              {/* File Upload Section */}
              {this.renderFileUpload()}

              {/* Remarks Section */}
              <div className="wallet-remarks-section">
                <label className="wallet-form-label">{i18n.t('remarks')}</label>
                <textarea
                  name="remarks"
                  value={input.remarks || ''}
                  onChange={this.handleChange}
                  rows={4}
                  className="wallet-textarea"
                  placeholder={i18n.t('enter_remarks')}
                />
              </div>

              {/* Action Buttons */}
              <div className="wallet-actions">
                <button type="button" className="wallet-btn wallet-btn-cancel" onClick={onClose}>
                  {i18n.t('cancel')}
                </button>
                <button
                  type="button"
                  className="wallet-btn wallet-btn-submit"
                  onClick={this.handleSubmit}
                  disabled={is_loading}
                >
                  {is_loading && <i className="fa fa-spinner fa-spin mr-2"></i>}
                  {i18n.t('approve')}
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
